import { useReveal } from "@/hooks/useReveal";

export const PageHero = ({ eyebrow, title, accent, subtitle, children }) => {
  const ref1 = useReveal();
  const ref2 = useReveal();
  const ref3 = useReveal();
  return (
    <section className="relative pt-32 pb-8 lg:pt-40 lg:pb-10 overflow-hidden">
      <div className="glow-blob bg-[hsl(var(--accent))] -top-32 left-1/2 -translate-x-1/2 w-[640px] h-[420px]" style={{ opacity: 0.16 }} />
      <div className="relative z-10 mx-auto max-w-7xl px-5 lg:px-10">
        {eyebrow && (
          <div ref={ref1} className="reveal flex items-center gap-3 mb-6">
            <span className="pulse-dot inline-block h-2 w-2 rounded-full bg-[hsl(var(--accent))]" />
            <span className="text-xs uppercase tracking-[0.22em] text-[hsl(var(--accent))] font-semibold">
              {eyebrow}
            </span>
          </div>
        )}
        <h1
          ref={ref2}
          className="reveal font-display text-[28px] sm:text-4xl lg:text-[56px] leading-[1.06] font-bold tracking-tight max-w-4xl"
        >
          {title}
          {accent && (
            <>
              {" "}
              <span className="italic font-light text-white/60">{accent}</span>
            </>
          )}
        </h1>
        {subtitle && (
          <p ref={ref3} className="reveal mt-7 text-lg text-white/65 max-w-2xl leading-relaxed">
            {subtitle}
          </p>
        )}
        {children && <div className="mt-8">{children}</div>}
      </div>
    </section>
  );
};
